"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgicalDefaults_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryDrug_1 = require("./SurgeryDrug");
var SurgeryDrugDosageType_1 = require("./SurgeryDrugDosageType");
var SurgeryGas_1 = require("./SurgeryGas");
var SurgicalDefaults_Factory = /** @class */ (function () {
    function SurgicalDefaults_Factory() {
    }
    SurgicalDefaults_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Dose: model.Dose,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurgerDrugRecord: SurgeryDrug_1.SurgeryDrug_Factory.CreateIncoming(model.SurgerDrugRecord),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryDrugDosageTypeRecord: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateIncoming(model.SurgeryDrugDosageTypeRecord),
            SurgeryDrugId: model.SurgeryDrugId,
            SurgeryGasId: model.SurgeryGasId,
            SurgeryGasRecord: SurgeryGas_1.SurgeryGas_Factory.CreateIncoming(model.SurgeryGasRecord),
        };
        return result;
    };
    SurgicalDefaults_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Dose: model.Dose,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurgerDrugRecord: SurgeryDrug_1.SurgeryDrug_Factory.CreateOutgoing(model.SurgerDrugRecord),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryDrugDosageTypeRecord: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateOutgoing(model.SurgeryDrugDosageTypeRecord),
            SurgeryDrugId: model.SurgeryDrugId,
            SurgeryGasId: model.SurgeryGasId,
            SurgeryGasRecord: SurgeryGas_1.SurgeryGas_Factory.CreateOutgoing(model.SurgeryGasRecord),
        };
        return result;
    };
    return SurgicalDefaults_Factory;
}());
exports.SurgicalDefaults_Factory = SurgicalDefaults_Factory;
